export const JOBS_DESTINATION_PARAM = "destination";

export enum JobsDestination {
  Statewide = "statewide",
  Origin = "origin",
}

const JOBS_DESTINATION_VALUES = Object.values(JobsDestination);

export function parseJobsDestination(
  value: string | string[] | undefined,
): JobsDestination {
  const match = JOBS_DESTINATION_VALUES.find(
    (destination) => destination === value,
  );

  if (!match) {
    return JobsDestination.Statewide;
  }

  return match;
}
